<template>
  <TheLog v-if="$store.state.auth.isSignin">
    <template v-slot:buttons>
      <a-button
        class="fl-right"
        style="margin: 5px"
        type="primary"
        shape="round"
        icon="file-excel"
        @click="downloadLogs"
      >다운로드</a-button>
    </template>
    <a-alert
      style="margin-bottom: 0.5em;"
      type="warning"
      message="최근 7일 동안의 내역입니다."
      description="이전의 로그를 확인하려면 날짜를 선택해주세요."
      closable
      showIcon
    />

    <div style="margin-bottom: 20px;">
      <a-row :gutter="8">
        <a-col :span="24" :md="24">
          <a-range-picker
            style="width: 100%"
            @change="onDateUpdate"
            :ranges="{
              오늘: [$moment(), $moment()],
              '이번 달': [$moment().startOf('month'), $moment().endOf('month')],
            }"
            format="LL"
          />
        </a-col>
        <a-col :span="24" :md="8">
          <a-select style="width: 100%" v-model="selected.wholesale" placeholder="도매">
            <a-select-option
              v-for="wholesale in $store.state.wholesale.wholesales"
              :key="wholesale.idx"
            >{{ wholesale.name }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="24" :md="13">
          <a-select mode="multiple" style="width: 100%" v-model="selected.filter" placeholder="필터">
            <a-select-option v-for="(filterName, index) of filter" :key="index">{{ filterName }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="24" :md="2">
          <a-button type="primary" icon="search" style="width: 90%" @click="searchLogs()">검색</a-button>
        </a-col>
      </a-row>
    </div>

    <div v-for="saib in $store.state.saib.saibsLog" :key="saib">
      <LogItem :saibs="$store.state.saib.logs[saib]" />
    </div>
  </TheLog>
</template>
<script>
import TheLog from "@/components/Log/TheLog";
import { mapActions } from "vuex";
import LogItem from "@/components/Log/LogItem";

export default {
  name: "LogStatus",
  data() {
    return {
      selected: {
        filter: []
      },
      filter: {
        success: "상태: 성공",
        failed: "상태: 실패",
        saib: "타입: 사입",
        exchange: "타입: 교환/반납"
      },
      saibs: [],
      logs: {}
    };
  },
  // eslint-disable-next-line vue/no-unused-components
  components: { TheLog, LogItem },
  methods: {
    ...mapActions(["refreshLogs", "downloadLogs"]),
    searchLogs() {
      this.refreshLogs(this.selected);
    },
    onDateUpdate(dates) {
      this.selected.startTime = dates[0];
      this.selected.endTime = dates[1];
    }
  },
  mounted() {
    this.refreshLogs(this.selected);
  }
};
</script>
